var map = {
	"./app.js": "w+19"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "s/E6";


//////////////////
// WEBPACK FOOTER
// ./src/opr/store/modules nonrecursive \.js$
// module id = s/E6
// module chunks = 1